var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideChanger",on:{"click":_vm.changeSlide}},[_c('span',[_vm._v(_vm._s(_vm.notNull === false ? ("About " + _vm.name) : 'Back to Product Image'))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60bd65e7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/ProductSlider.vue
// module id = GAOG
// module chunks = 0